<template>
  <img src="@/assets/images/logos/company-logo-astana-opera.webp"/>
</template>
<script setup>
</script>